import { render } from "./PointRating.vue?vue&type=template&id=d8e581ea&scoped=true"
import script from "./PointRating.vue?vue&type=script&lang=js"
export * from "./PointRating.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&id=d8e581ea&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e581ea"]])

export default __exports__